import { BrowserRouter, Routes, Route, HashRouter } from 'react-router-dom';
import Login from './Login';
import Menu from './Menu';
import PrivateRoute from './PrivateRoute';
import Perfil from './perfil';
import Agendamento from './agendamentos';
import Vacinas from './vacinas';
import Exames from './exames';
import Unidades from './unidades';
import Contato from './contato';
import Especialidades from './especialidades';
import GovbrCallback from './GovbrCallback';

//console.log('Aplicação iniciada!', window.location.pathname);

function App() {
  return (
    <BrowserRouter basename="/">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/govbr-callback" element={<GovbrCallback />} />

          <Route
            path="/Menu"
            element={
              <PrivateRoute>
                <Menu />
              </PrivateRoute>
            }
          />
          <Route
            path="/perfil"
            element={
              <PrivateRoute>
                <Perfil />
              </PrivateRoute>
            }
          />
          <Route
            path="/agendamentos"
            element={
              <PrivateRoute>
                <Agendamento />
              </PrivateRoute>
            }
          />
          <Route
            path="/vacinas"
            element={
              <PrivateRoute>
                <Vacinas />
              </PrivateRoute>
            }
          />
          <Route
            path="/exames"
            element={
              <PrivateRoute>
                <Exames />
              </PrivateRoute>
            }
          />
          <Route
            path="/unidades"
            element={
              <PrivateRoute>
                <Unidades />
              </PrivateRoute>
            }
          />
          <Route
            path="/contato"
            element={
              <PrivateRoute>
                <Contato />
              </PrivateRoute>
            }
          />
          {/* <Route
          path="/especialidades"
          element={
            <PrivateRoute>
              <Especialidades />
              </PrivateRoute>
          }
        /> */}
          <Route path="/especialidades/:codigoUnidade" element={<Especialidades />} />
        </Routes>
    </BrowserRouter>
  );
}
export default App;
